import React from 'react';

import { BankFilled } from '@ant-design/icons';
import {
  CardAvatar,
  CardHeader,
  CardProgress,
  VerticalSpace,
} from '@brokerbay/design-components';

import PrimaryRoleForm, { PrimaryRoleFormValues } from './PrimaryRoleForm';
import { useOrgOnboardingContext } from '../../../contexts/OrgOnboardingContext';
import { OrgOnboardingStep, UserOnboardingStep } from '../../../constants';

export type PrimaryRoleViewProps = {
  handleGoNextStep: (nextStep: OrgOnboardingStep | UserOnboardingStep) => void;
};

const PrimaryRoleView = ({ handleGoNextStep }: PrimaryRoleViewProps) => {
  const { orgProfile, updateLocalOrgProfile } = useOrgOnboardingContext();

  const handleSubmit = (values: PrimaryRoleFormValues) => {
    updateLocalOrgProfile({ ...values });
    const nextStep = values.isLicensed
      ? OrgOnboardingStep.FIND_MEMBER
      : UserOnboardingStep.PROFILE;
    handleGoNextStep(nextStep);
  };

  return (
    <VerticalSpace>
      <CardHeader
        title="What is your role at the Brokerage?"
        icon={<CardAvatar icon={BankFilled} />}
        onRequestStepBack={null}
      />

      <PrimaryRoleForm
        overrideLabel={orgProfile?.overrideLabel}
        onSubmit={handleSubmit}
      />

      <CardProgress percent={(2 / 6) * 100} />
    </VerticalSpace>
  );
};

export default PrimaryRoleView;
